import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useId, useRef, useState } from 'react';
export function LinkDialog({ title, initial, isValid, onSubmit, onCancel, labels, }) {
    const titleId = useId();
    const errorId = useId();
    const [value, setValue] = useState(initial);
    const [invalid, setInvalid] = useState(false);
    const input = useRef(null);
    useEffect(() => {
        input.current?.focus();
        input.current?.select();
    }, []);
    return (_jsx("div", { className: "dialog", role: "presentation", children: _jsxs("form", { className: "dialog__panel", role: "dialog", "aria-modal": "true", "aria-labelledby": titleId, noValidate: true, onKeyDown: (event) => {
                if (event.key === 'Escape') {
                    event.preventDefault();
                    event.stopPropagation();
                    onCancel();
                }
            }, onSubmit: (event) => {
                event.preventDefault();
                const url = value.trim();
                if (!isValid(url)) {
                    setInvalid(true);
                    input.current?.focus();
                    return;
                }
                onSubmit(url);
            }, children: [_jsx("h2", { id: titleId, className: "dialog__title", children: title }), _jsxs("label", { className: "link-dialog__field", children: [_jsx("span", { children: labels.url }), _jsx("input", { ref: input, type: "url", inputMode: "url", autoComplete: "url", placeholder: "https://", value: value, "aria-invalid": invalid || undefined, "aria-describedby": invalid ? errorId : undefined, onChange: (event) => {
                                setValue(event.target.value);
                                setInvalid(false);
                            } })] }), invalid ? (_jsx("p", { id: errorId, className: "detail__error", role: "alert", children: labels.invalid })) : null, _jsxs("div", { className: "dialog__actions", children: [_jsx("button", { type: "button", onClick: onCancel, children: labels.cancel }), _jsx("button", { type: "submit", className: "dialog__primary", children: labels.submit })] })] }) }));
}
//# sourceMappingURL=LinkDialog.js.map